import { useFormContext } from 'react-hook-form'

import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { BaseFormFields } from '@/components/forms/pricing-interface/BaseSchemaFormFields'
import { SchemaType } from '@/components/forms/pricing-interface/RunScenarioForm/RunScenarioForm'

export interface RunScenarioFormFieldsProps {}

export const RunScenarioFormFields: React.FC<RunScenarioFormFieldsProps> = ({}) => {
  const { setValue, control, formState, register, watch } = useFormContext<SchemaType>()

  const input_type = watch('input_type')

  return (
    <div className={'@container flex flex-col gap-4'}>
      <FormField
        control={control}
        name="input_type"
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Input Type</FormLabel>
              <SelectInput
                size="sm"
                disabled={formState.isSubmitting}
                value={value}
                onValueChange={(val) =>
                  setValue('input_type', val as 'default_scenario' | 'custom_scenario', {
                    shouldValidate: true,
                  })
                }
                options={['default_scenario', 'custom_scenario'].map((v) => ({
                  label: v,
                  value: v,
                }))}
              />
            </FormItem>
          )
        }}
      />
      <BaseFormFields />
      {input_type === 'custom_scenario' && (
        <div className={'grid gap-4 @xs:grid-cols-2'}>
          <FormField
            control={control}
            name="spot"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Spot</FormLabel>
                  <Input inputSize="sm" {...register('spot')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
          <FormField
            control={control}
            name="time"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Time</FormLabel>
                  <Input inputSize="sm" {...register('time')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
        </div>
      )}
    </div>
  )
}
